/* eslint-disable id-length */
import { convert, LocalDate, ZoneId } from '@js-joda/core';

import { AppointmentView } from '@dreryk/egabinet-dashboard-frontend-api';

import { ChartData } from '@dreryk/react-charts';
import { TranslateFunction } from '@dreryk/react-common';

import { CHART_CHUNK_SIZE, CHART_COLORS, CHART_ELEMENTS, CHART_LEGEND_LABELS } from '../shared/Chart.utils';

const fillMissingDates = (appointments: AppointmentView[]): AppointmentView[] => {
   const today = LocalDate.now();
   const dateMap = new Map<string, AppointmentView>();

   appointments.forEach((appointment) => {
      const dateStr = appointment.appointmentDate.toString();
      dateMap.set(dateStr, appointment);
   });

   const filledAppointments: AppointmentView[] = [];
   for (let i = 0; i < CHART_ELEMENTS; i++) {
      const currentDate = today.minusDays(i);
      const dateStr = currentDate.toString();

      if (dateMap.has(dateStr)) {
         filledAppointments.push(dateMap.get(dateStr)!);
      } else {
         filledAppointments.push({
            appointmentDate: currentDate,
            appointmentCount: 0,
         } as AppointmentView);
      }
   }

   return filledAppointments.reverse();
};

export const mapAppointmentsToChartData = (
   appointments: AppointmentView[],
   translate: TranslateFunction
): ChartData => {
   const chartData: ChartData = [];
   const appointmentsPart = appointments.splice(-CHART_ELEMENTS);
   const filledAppointments = fillMissingDates(appointmentsPart);

   for (let i = 0; i < CHART_ELEMENTS; i += CHART_CHUNK_SIZE) {
      const chunk = filledAppointments.slice(i, i + CHART_CHUNK_SIZE);
      chartData.push({
         color: CHART_COLORS[(i / CHART_CHUNK_SIZE) % CHART_COLORS.length],
         id: `week-${i / CHART_CHUNK_SIZE + 1}`,
         name: translate(CHART_LEGEND_LABELS[i / CHART_CHUNK_SIZE]),
         values: chunk.map((appointment) => ({
            x: new Date(convert(appointment.appointmentDate.atTime(0, 0).minusHours(1), ZoneId.UTC).toDate()),
            y: appointment.appointmentCount,
         })),
      });
   }

   return chartData;
};
